var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
export class HistoryRecentAnswers {
    parent;
    answersFinishedSincePageLoad = observable.array();
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get history() {
        return this.parent;
    }
    get app() {
        return this.history.app;
    }
    get latestFinishedAnswerSincePageload() {
        return this.answersFinishedSincePageLoad
            .concat()
            .reverse()
            .find(answer => answer.finishDate);
    }
}
__decorate([
    observable.shallow
], HistoryRecentAnswers.prototype, "answersFinishedSincePageLoad", void 0);
